import React from 'react'
import Media from 'react-media'

import tokens from '@cinch/oxd-utils/tokens/src'

import WbacLarge from '../../assets/logo-wbac-large.png'

import Wbac from '../../assets/logo-wbac.png'

import * as styles from './enabled-by.module.css'

const EnabledBy: React.FC<any> = () => (
  <div className={styles.enabled}>
    Enabled by
    <Media defaultMatches={true} query={tokens.customMedia.m}>
      {(matches) => <img src={matches ? WbacLarge : Wbac} alt={'Enabled by webuyanycar.com'} className={styles.img} />}
    </Media>
  </div>
)

export default EnabledBy
